import "core-js/modules/es.array.push.js";
import { createNamespacedHelpers } from "vuex";
import { GameState, GRID_SIZE, DRAG_Y_OFFSET, generateRandomBlock, COLOR_MAP } from '@utils/game/zenBlocks/constants.js';
import { aesEncrypt, getRandomElement, isOpenMobile } from '@utils/index.js';
import { gameAdv } from "@utils/gameAdv.js";
import vailcode from "@utils/errcode";
const walletVuex = createNamespacedHelpers("wallet");
export default {
  name: "zenBlocksPage",
  computed: {
    ...walletVuex.mapState(["isMobile", "theme", 'setting']),
    startBtnText() {
      return this.lastScore > 0 ? 'Start Game (Ad)' : this.$lang('Start Game');
    },
    nextBtnText() {
      return (this.gameState.level + 1) % ADV_ROUND === 0 ? this.$lang('Continue (Ad)') : this.$lang('Next Level');
    },
    flatGrid() {
      return this.gameState.grid.flatMap((row, r) => row.map((cell, c) => ({
        r,
        c,
        cell
      })));
    },
    boardRect() {
      if (!this.$refs.board) return {
        top: 0,
        left: 0,
        width: 0,
        height: 0
      };
      return this.$refs.board.getBoundingClientRect();
    }
  },
  data() {
    return {
      gameState: {
        ...GameState
      },
      revives: 10,
      maxRevives: 10,
      GRID_SIZE,
      COLOR_MAP,
      DRAG_Y_OFFSET,
      lastScore: 0,
      timeVal: null,
      stimeVal: null,
      leftTime: 0,
      prizePool: 0,
      timePeriod: "",
      userReward: null,
      popUserRewardShow: false,
      popGameRankShow: false,
      popStartShow: false,
      popLostShow: false,
      popWinShow: false,
      popOpenMobileShow: false,
      activeBlock: null,
      dragPos: {
        x: 0,
        y: 0
      }
    };
  },
  watch: {
    'gameState.status'(newStatus, oldStatus) {
      if (newStatus === this.GameStatus.GAMEOVER) {
        this.popLostShow = true;
      }
      if (newStatus === this.GameStatus.LEVEL_WIN) {
        this.popWinShow = true;
      }
    },
    'gameState.score': {
      handler() {
        clearTimeout(this.timeVal);
        this.timeVal = setTimeout(() => {
          this.end();
        }, 200);
      }
    },
    'gameState.isGameOver': {
      handler(newVal, oldVal) {
        if (newVal) {
          this.popLostShow = true;
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    try {
      clearTimeout(this.stimeVal);
      this.end();
    } catch (error) {}
    this.$nextTick(() => {
      next();
    });
  },
  methods: {
    cellSize(scale = 1) {
      return (this.boardRect.width / GRID_SIZE > 0 ? this.boardRect.width / GRID_SIZE : 32) * scale;
    },
    canPlaceBlock(grid, shape, row, col) {
      for (let r = 0; r < shape.length; r++) {
        for (let c = 0; c < shape[0].length; c++) {
          if (shape[r][c]) {
            const targetRow = row + r;
            const targetCol = col + c;
            if (targetRow < 0 || targetRow >= GRID_SIZE || targetCol < 0 || targetCol >= GRID_SIZE || grid[targetRow][targetCol] !== null) {
              return false;
            }
          }
        }
      }
      return true;
    },
    checkGameOver(grid, availableBlocks) {
      const blocksToCheck = availableBlocks.filter(b => b !== null);
      if (blocksToCheck.length === 0) return false;
      for (const block of blocksToCheck) {
        if (!block) continue;
        for (let r = 0; r < GRID_SIZE; r++) {
          for (let c = 0; c < GRID_SIZE; c++) {
            if (this.canPlaceBlock(grid, block.shape, r, c)) {
              return false;
            }
          }
        }
      }
      return true;
    },
    handlePlaceBlock(row, col) {
      if (!this.activeBlock) return;
      const {
        block,
        index
      } = this.activeBlock;
      if (this.canPlaceBlock(this.gameState.grid, block.shape, row, col)) {
        const newGrid = this.gameState.grid.map(r => [...r]);
        let blocksPlaced = 0;
        for (let r = 0; r < block.shape.length; r++) {
          for (let c = 0; c < block.shape[0].length; c++) {
            if (block.shape[r][c]) {
              newGrid[row + r][col + c] = block.color;
              blocksPlaced++;
            }
          }
        }
        const rowsToClear = [];
        const colsToClear = [];
        for (let r = 0; r < GRID_SIZE; r++) {
          if (newGrid[r].every(cell => cell !== null)) rowsToClear.push(r);
        }
        for (let c = 0; c < GRID_SIZE; c++) {
          if (newGrid.every(rowArr => rowArr[c] !== null)) colsToClear.push(c);
        }
        let linesCleared = rowsToClear.length + colsToClear.length;
        let scoreGain = blocksPlaced + linesCleared * 10 * (linesCleared + this.gameState.combo);
        rowsToClear.forEach(r => newGrid[r].fill(null));
        colsToClear.forEach(c => {
          for (let r = 0; r < GRID_SIZE; r++) newGrid[r][c] = null;
        });
        const nextAvailable = [...this.gameState.availableBlocks];
        nextAvailable[index] = null;
        if (nextAvailable.every(b => b === null)) {
          nextAvailable[0] = generateRandomBlock();
          nextAvailable[1] = generateRandomBlock();
          nextAvailable[2] = generateRandomBlock();
        }
        const newScore = this.gameState.score + scoreGain;
        const isOver = this.checkGameOver(newGrid, nextAvailable);
        const newGameState = {
          ...this.gameState,
          grid: newGrid,
          score: newScore,
          availableBlocks: nextAvailable,
          combo: linesCleared > 0 ? this.gameState.combo + 1 : 0,
          isGameOver: isOver
        };
        this.gameState = newGameState;
        this.activeBlock = null;
        if (linesCleared > 0) {
          //const randomPhrase = ZEN_PHRASES[Math.floor(Math.random() * ZEN_PHRASES.length)];
        }
      } else {
        this.activeBlock = null;
      }
    },
    // 处理拖动开始
    handleDragStart(e, block, index) {
      // 关键：捕获指针，确保即使手指滑出目标元素，move和up事件依然触发
      e.target.setPointerCapture(e.pointerId);
      e.preventDefault();
      e.stopPropagation();
      this.activeBlock = {
        block,
        index
      };
      this.dragPos = {
        x: e.clientX,
        y: e.clientY
      };
    },
    // 处理拖动中
    handlePointerMove(e) {
      if (this.activeBlock) {
        this.dragPos = {
          x: e.clientX,
          y: e.clientY
        };
        console.log('handlePointerMove', this.dragPos);
      }
    },
    // 处理松开
    handlePointerUp(e) {
      if (!this.activeBlock) return;

      // 释放指针捕获
      e.target.releasePointerCapture(e.pointerId);
      if (!this.$refs.board) {
        this.activeBlock = null;
        return;
      }
      const rect = this.$refs.board.getBoundingClientRect();
      const cellSize = rect.width / GRID_SIZE;

      // 逻辑位置计算：考虑 Y 偏移量
      const visualX = e.clientX - rect.left;
      const visualY = e.clientY + DRAG_Y_OFFSET - rect.top;
      const pieceWidth = this.activeBlock.block.shape[0].length * cellSize;
      const pieceHeight = this.activeBlock.block.shape.length * cellSize;
      const col = Math.round((visualX - pieceWidth / 2) / cellSize);
      const row = Math.round((visualY - pieceHeight / 2) / cellSize);
      this.handlePlaceBlock(row, col);
    },
    async resetGame() {
      // const callback = async (res) => {
      this.popStartShow = false;
      this.popLostShow = false;
      await this.start();
      this.gameState.grid = Array(GRID_SIZE).fill(null).map(() => Array(GRID_SIZE).fill(null));
      this.gameState.score = 0;
      this.gameState.availableBlocks = [generateRandomBlock(), generateRandomBlock(), generateRandomBlock()];
      this.gameState.isGameOver = false;
      this.gameState.combo = 0;
      this.revives = this.maxRevives;
      // }

      //  if(this.lastScore > 0){
      //      let advData = getRandomElement(this.advList);
      //     if(advData){
      //         gameAdv.show(advData,this.timePeriod,(res)=>{
      //             callback(res);
      //         },this)
      //     }else{
      //         callback(null);
      //     }
      // }else{
      //     callback(null);
      // }
    },

    handleRevive() {
      if (this.revives <= 0) return;
      const callback = res => {
        this.popLostShow = false;
        this.revives = this.revives - 1 >= 0 ? this.revives - 1 : 0;
        const newGrid = this.gameState.grid.map(r => [...r]);
        // H5端清理范围稍大，增强爽感
        for (let r = 2; r <= 7; r++) {
          for (let c = 2; c <= 7; c++) {
            newGrid[r][c] = null;
          }
        }
        this.gameState.grid = newGrid;
        this.gameState.isGameOver = false;
      };
      try {
        let advData = getRandomElement(this.advList);
        if (advData) {
          gameAdv.show(advData, this.timePeriod, res => {
            callback(res);
          }, this);
        } else {
          callback(null);
        }
      } catch (error) {
        callback(null);
      }
    },
    async start() {
      let rs = await this.$http.post("/game/start", {
        game_type: "zenBlocks"
      });
      vailcode(rs, () => {
        this.prizePool = rs.data.keys ?? 0;
        this.timePeriod = rs.data.time_period ?? "";
        this.leftTime = rs.data.left_time ?? 0;
        this.lastScore = rs.data.last_score ?? 0;
      });
    },
    async end() {
      if (this.lastScore >= this.gameState.score) return;
      this.lastScore = this.gameState.score;
      let gameData = aesEncrypt(JSON.stringify({
        game_type: "zenBlocks",
        level: 1,
        score: this.gameState.score,
        time_period: this.timePeriod,
        time: new Date().getTime()
      }));
      let rs = await this.$http.post("/game/score", {
        gameData: gameData,
        '_n': 1
      });
      if (rs.code == 0) {
        // this.level = rs.data.level ?? 1;
        // this.score = rs.data.score ?? 0;
        this.prizePool = rs.data.keys ?? 0;
      }
    },
    async init() {
      let rs = await this.$http.post("/game/init", {
        game_type: "zenBlocks"
      });
      vailcode(rs, () => {
        this.leftTime = rs.data.left_time ?? 0;
        this.prizePool = rs.data.keys ?? 0;
        this.advList = rs.data.advList ?? [];
        this.timePeriod = rs.data.time_period ?? "";
        this.userReward = rs.data.userReward ?? null;
        this.lastScore = rs.data.score ?? 0;
        if (this.userReward?.total_keys > 0 || this.userReward?.total_taps > 0) {
          setTimeout(() => {
            this.popUserRewardShow = true;
          }, 500);
        }
        this.countDown();
      });
    },
    countDown() {
      clearTimeout(this.stimeVal);
      this.leftTime = this.leftTime - 1;
      this.$nextTick(async () => {
        if (this.leftTime <= 0) {
          await this.init();
          this.popStartShow = true;
        } else {
          this.stimeVal = setTimeout(() => {
            this.countDown();
          }, 1000);
        }
      });
    },
    handleCancel() {
      this.popLostShow = false;
      this.popStartShow = true;
    },
    handleConfirm() {
      this.revives > 0 ? this.handleRevive() : this.handleCancel();
    },
    async handleGetRewardConfirm() {
      let rs = await this.$http.post("/game/get/reward", {
        game_type: "zenBlocks"
      });
      vailcode(rs, () => {
        this.popUserRewardShow = false;
      });
    },
    viewRank() {
      this.$nextTick(() => {
        //  this.$router.push(`/game/rank`)
        //  console.log(this.$router)
        this.end();
        this.popGameRankShow = true;
      });
    }
  },
  async mounted() {
    if (!isOpenMobile()) {
      this.popOpenMobileShow = true;
      return;
    }
    await this.init();
    this.popStartShow = true;
    this.$nextTick(() => {
      const topH = this.$refs.topBox.clientHeight;
      const boardH = this.$refs.board.clientHeight;
      this.$refs.availableBlocksBox.style.height = window.innerHeight - (topH + boardH) + 'px';
    });
  }
};